import { createApi, fakeBaseQuery } from '@reduxjs/toolkit/query/react'
import pako from 'pako'

import { FeatureType } from 'clickNgo/configs/feature'
import { getAccessToken } from 'cng-common/helpers/access'
import settings from 'src/config/settings'

import type { PbmCockpitResponse } from '../model'

export const pbmCockpitApi = createApi({
  reducerPath: `${FeatureType.P360Api}/pbmCockpitApi`,
  baseQuery: fakeBaseQuery(),
  endpoints: (build) => ({
    getPbmCockpitGzip: build.query<PbmCockpitResponse, void>({
      queryFn: async (_arg, { signal }) => {
        try {
          const url = `${settings.httpsServices.partner360}/api/v0/pbmCockpit/pbmCockpitGzip`
          const accessToken = getAccessToken()
          const response = await fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${accessToken}`,
            },
            body: JSON.stringify({}),
            signal,
          })

          if (!response.ok) {
            return { error: { status: response.status, data: response.statusText } }
          }

          const gzipData = await response.arrayBuffer()
          const ungzippedData = pako.ungzip(new Uint8Array(gzipData))
          const unpackedData = new TextDecoder('utf-16le').decode(ungzippedData)

          const parsedData = JSON.parse(unpackedData) as PbmCockpitResponse

          return { data: parsedData }
        } catch (error) {
          return { error: { status: 'CUSTOM_ERROR', data: String(error) } }
        }
      },
    }),
  }),
})

export const { useGetPbmCockpitGzipQuery } = pbmCockpitApi
